exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".active[data-v-336b0e42]{font-weight:700}.active[data-v-336b0e42]:before{content:\"\";position:absolute;width:100%;height:3px;background-color:var(--portalPrimaryTextColor);bottom:-7px}", ""]);

// exports
